<template>
  <div style="padding:10px;background-color: #F5F5F5;min-height: 100%">

    <Card  :bordered="false" :dis-hover="true" style="margin-bottom:10px;">
      <div style="text-align:left">
        <Row :gutter="16">
          <Col span="15">
            <Button type="primary" @click="load">刷新</Button>
          </Col>

        </Row>
      </div>
    </Card>

    <Card :dis-hover="true">
      <Spin fix v-if="loading"></Spin>
        <el-table :data="list" size="small" style="width: 100%" :border="1">
          <el-table-column prop="id" label="订单编号" :show-tooltip-when-overflow="true" width="80"></el-table-column>
          <el-table-column prop="unionId" label="报名用户" width="120"
                           :show-tooltip-when-overflow="true"></el-table-column>
          <el-table-column prop="type" width="100" label="订单类型" align="center" :show-tooltip-when-overflow="true">
            <template slot-scope="scope">
              <Tag color="primary" >公开课</Tag>
            </template>
          </el-table-column>
          <el-table-column prop="price" label="订单金额" width="100" :show-tooltip-when-overflow="true">
            <template slot-scope="scope">￥{{ scope.row.price }}</template>
          </el-table-column>
          <el-table-column prop="zfstate" label="订单状态" width="120" :show-tooltip-when-overflow="true" align="center">
            <template slot-scope="scope">
              <Tag color="red" v-if="scope.row.zfstate=='未支付'">{{ scope.row.zfstate }}</Tag>
              <Tag color="blue" v-if="scope.row.zfstate=='已支付'">{{ scope.row.zfstate }}</Tag>
              <Tag color="default" v-if="scope.row.zfstate=='已取消'">{{ scope.row.zfstate }}</Tag>
            </template>
          </el-table-column>
          <el-table-column prop="fxid" label="分享用户" :show-tooltip-when-overflow="true" width="80"></el-table-column>
          <el-table-column prop="zfstate" label="审核状态" width="120" :show-tooltip-when-overflow="true" align="center">
            <template slot-scope="scope">
              <div v-if="scope.row.fxid">
                <Tag color="default" v-if="scope.row.bmstate=='报名无效'">{{ scope.row.bmstate }}</Tag>
                <Tag color="blue" v-if="scope.row.bmstate=='报名审核中'">{{ scope.row.bmstate }}</Tag>
                <Tag color="green" v-if="scope.row.bmstate=='报名有效'">{{ scope.row.bmstate }}</Tag>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="remarks" label="更多信息" :show-tooltip-when-overflow="true"></el-table-column>
          <el-table-column prop="addTime" label="报名时间" :show-tooltip-when-overflow="true"></el-table-column>
          <el-table-column prop="msg" label="操作" width="160" fixed="right">
            <template slot-scope="scope">
              <a @click="d2.modal=true;d2.id=scope.row.id;d2.token=scope.row.token">详情</a>

              <span v-if="scope.row.qx==0&&scope.row.fxid&&scope.row.fxid!='none'">
              <cite>|</cite>
              <a @click="modal2=true;detail.id=scope.row.id;detail.bmstate=scope.row.bmstate;detail.fxmoney=null">审核</a>
            </span>
            </template>
          </el-table-column>
        </el-table>
    </Card>

    <Card  :bordered="false" dis-hover style="text-align: center;margin-top:10px">
      <Page :total="count" show-total :page="page" @on-page-size-change="limitChange"  show-elevator @on-change="change"  show-sizer :page-size-opts="[10, 30,50,100]"></Page>
    </Card>

    <Modal
      v-model="modal1"
      title="增加或编辑"
      @on-ok="save"
      @on-cancel="cancel">
      <Form :label-width="80">
        <FormItem label="">
          <Input v-model="detail.id"/>
        </FormItem>
        <FormItem label="联系人ID">
          <Input v-model="detail.contactId"/>
        </FormItem>
        <FormItem label="小程序用户">
          <Input v-model="detail.unionId"/>
        </FormItem>
        <FormItem label="课程场次ID">
          <Input v-model="detail.productId"/>
        </FormItem>
        <FormItem label="培训联系人">
          <Input v-model="detail.traineeIds"/>
        </FormItem>
        <FormItem label="报名人数">
          <Input v-model="detail.count"/>
        </FormItem>
        <FormItem label="报名时间">
          <Input v-model="detail.addTime"/>
        </FormItem>

      </Form>
    </Modal>

    <Drawer title="详细信息" v-model="d2.modal" width="700">
      <ApplyDetail :id="d2.id" :token="d2.token"></ApplyDetail>
    </Drawer>

    <Modal
      v-model="modal2"
      title="审核报名是否有效"
      @on-ok="save">
      <Form :label-width="80">
        <FormItem label="报名状态" required>
          <Select v-model="detail.bmstate">
            <Option value="报名审核中" label="报名审核中"></Option>
            <Option value="报名无效" label="报名无效"></Option>
            <Option value="报名有效" label="报名有效"></Option>
          </Select>
        </FormItem>
      </Form>
    </Modal>


  </div>
</template>

<script>
import ApplyDetail from './ApplyDetail'
export default {
  components:{ApplyDetail},
  data(){
    return{
      baseUrl:'/api/apply/',
      list:[],
      page:1,
      count:0,
      limit:10,
      modal1:false,
      detail:{},
      serch:{
        key:'',
        state:0
      },
      loading:false,
      d2:{
        modal:false,
        id:0,
        token:'',
      },
      modal2: false,
    }
  },
  methods:{
    wx(row){//设置为无效报名
      this.detail.id = row.id;
      this.detail.state = 1;
      this.$Modal.confirm({
        title: '系统提示',
        content: '确定要标记为无效报名吗',
        onOk: () => {
          this.save();
        }
      });

    },
    load(){
      let that = this;
      let params = [];
      if(this.serch.key){
        params.push('t.id@=@'+this.serch.key);
      }
      params.push('t.state@=@'+this.serch.state);
      that.loading = true;
      this.$axios.get(this.baseUrl+'findall?page='+this.page+'&limit='+this.limit+'&params='+params).then(function(rs){
        that.list = rs.data.data;
        that.count = rs.data.count;
        that.loading = false;
      });
    },
    limitChange(val){
      this.limit = val;
      this.load();
    },
    change(val){
      this.page = val;
      this.load();
    },
    save(){
      let that = this;
      let data = Object.assign({}, this.detail);
      this.$axios({url:this.baseUrl+'save',method:'post',data:this.$qs.stringify(data)}).then(function(rs){
        that.toast(rs.data);
        if(rs.data.success){
          that.detail = {};
        }
      });
    },
    edit(id){
      let that = this;
      this.$axios.get(this.baseUrl+'getById?id='+id).then(function(rs){
        that.detail = rs.data;
        that.modal1 = true;
      });
    },
    remove(id){
      this.$Modal.confirm({
        title: '系统提示',
        content: '确定要删除吗',
        onOk: () => {
          let that = this;
          this.$axios.get(this.baseUrl+'delete?ids='+id).then(function(rs){
            that.toast(rs.data);
          });
        },
      });
    },
    toast(data){
      if(data.success){
        this.load();
        this.$Message.success(data.msg);
      }else{
        this.$Message.error(data.msg);
      }
    }
  },
  created(){
    this.load();
  }
}
</script>



// WEBPACK FOOTER //
// src/components/apply/Apply.vue